module.exports = __webpack_public_path__ + "static/media/news2.1e1fd99b.png";